import { render, staticRenderFns } from "./FormBoxRadio.vue?vue&type=template&id=97132cd2&scoped=true&"
import script from "./FormBoxRadio.vue?vue&type=script&lang=js&"
export * from "./FormBoxRadio.vue?vue&type=script&lang=js&"
import style0 from "./FormBoxRadio.vue?vue&type=style&index=0&id=97132cd2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97132cd2",
  null
  
)

export default component.exports